module.exports = __webpack_public_path__ + "housingStatic/img/jxgj.fd097d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/park_bg/jxgj.jpg
// module id = BleO
// module chunks = 2